<form class="d-flex flex-column gap-2" [formGroup]="form">
  <div class="apm-card shadow">
    <div class="chiller-free-st-card-title">{{ 451846 | apmTranslate }}</div>
    <hr class="gray-divider-1" />

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">{{ 444899 | apmTranslate }}</div>
      <div class="chiller-free-st-field-control">
        <apm-select
          [items]="unitSystemOptions"
          [useResourceTemplate]="true"
          [clearable]="false"
          (selectChange)="onSystemUnitChange($event)"
          bindLabel="label"
          bindValue="value"
          formControlName="uomSystem"
        ></apm-select>
      </div>
    </div>
  </div>

  <!-- MACHINE CONFIGURATION -->
  <div class="apm-card shadow">
    <div class="chiller-free-st-card-title">{{ 451847 | apmTranslate }}</div>
    <hr class="card-divider" />

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">{{ 28070 | apmTranslate }}*</div>
      <div class="chiller-free-st-field-control">
        <apm-select
          [items]="store.machineSeriesList()"
          [clearable]="false"
          (selectChange)="onSeriesChange($event)"
          bindLabel="softwareDisplayName"
          bindValue="id"
          formControlName="machineSeriesId"
        ></apm-select>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">{{ 25995 | apmTranslate }}*</div>
      <div class="chiller-free-st-field-control">
        <apm-select
          [items]="compressorSeriesOptions()"
          [multiple]="true"
          [clearable]="false"
          [loading]="store.compressorSeriesLoading()"
          [closeOnSelect]="false"
          (selectChange)="onCompressorSeriesChange()"
          bindLabel="name"
          bindValue="name"
          formControlName="compSeriesList"
        ></apm-select>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">{{ 456931 | apmTranslate }}</div>
      <div class="chiller-free-st-field-control">
        <apm-select
          [items]="yesNoOptions"
          [clearable]="false"
          [useResourceTemplate]="true"
          bindLabel="label"
          bindValue="value"
          formControlName="lowLift"
        ></apm-select>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">{{ 25998 | apmTranslate }}*</div>
      <div class="chiller-free-st-field-control">
        <apm-select
          [items]="availablePowerSupplies()"
          [clearable]="false"
          bindLabel="desc"
          bindValue="id"
          formControlName="powerSupplyId"
        ></apm-select>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">{{ 456933 | apmTranslate }}*</div>
      <div class="chiller-free-st-field-control">
        <apm-select [items]="availableCircuits()" [clearable]="false" formControlName="circuitNum"></apm-select>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">{{ 25958 | apmTranslate }}*</div>
      <div class="chiller-free-st-field-control">
        <apm-select
          [items]="availableRefrigerants()"
          [clearable]="false"
          bindLabel="name"
          bindValue="name"
          formControlName="ref"
        ></apm-select>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">
        {{ 26000 | apmTranslate }}
        @if (fieldMappings().coolingCapacity.symbol) {
          [{{ fieldMappings().coolingCapacity.symbol }}]
        }
        *
      </div>
      <div class="chiller-free-st-field-control">
        <apm-convertible-input formControlName="coolingCapacity" [mapping]="fieldMappings().coolingCapacity.mapping" [uomSystem]="store.uomSystem()"></apm-convertible-input>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">{{ 459034 | apmTranslate }}*</div>
      <div class="chiller-free-st-field-control">
        <apm-select
          [items]="standardConditions()"
          [clearable]="false"
          [useResourceTemplate]="true"
          (selectChange)="onConditionChange()"
          bindLabel="resourceId"
          bindValue="descKey"
          formControlName="standardConditionDesc"
        ></apm-select>
      </div>
    </div>

    @if (showAccopRegion()) {
      <div class="chiller-free-st-field-row">
        <div class="chiller-free-st-field-label">{{ 456930 | apmTranslate }}</div>
        <div class="chiller-free-st-field-control">
          <apm-select
            [items]="store.accopRegionList()"
            [clearable]="false"
            [bindLabel]="regionNameField()"
            bindValue="id"
            formControlName="accopRegionId"
          ></apm-select>
        </div>
      </div>
    }

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">
        {{ 457031 | apmTranslate }}
        @if (fieldMappings().cop.symbol) {
          [{{ fieldMappings().cop.symbol }}]
        }
      </div>
      <div class="chiller-free-st-field-control">
        <apm-convertible-input formControlName="cop" [mapping]="fieldMappings().cop.mapping" [uomSystem]="store.uomSystem()" [computeFn]="copComputeFn"></apm-convertible-input>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">{{ 456932 | apmTranslate }}</div>
      <div class="chiller-free-st-field-control">
        <apm-select
          [items]="yesNoOptions"
          [clearable]="false"
          [useResourceTemplate]="true"
          bindLabel="label"
          bindValue="value"
          formControlName="useEcon"
        ></apm-select>
      </div>
    </div>
  </div>

  <!-- EVAPORATOR -->
  <div class="apm-card shadow">
    <div class="chiller-free-st-card-title">{{ 457032 | apmTranslate }}</div>
    <hr class="card-divider" />

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">{{ 456941 | apmTranslate }}</div>
      <div class="chiller-free-st-field-control">
        <apm-select
          [items]="evapInletTypes"
          [clearable]="false"
          [useResourceTemplate]="true"
          bindLabel="resourceId"
          bindValue="id"
          formControlName="evapInletType"
          (selectChange)="onEvapInletTypeChange()"
        ></apm-select>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">
        {{ 456943 | apmTranslate }}
        @if (fieldMappings().evapInletValue.symbol) {
          [{{ fieldMappings().evapInletValue.symbol }}]
        }
        *
      </div>
      <div class="chiller-free-st-field-control">
        <apm-convertible-input formControlName="evapInletValue" [mapping]="fieldMappings().evapInletValue.mapping" [uomSystem]="store.uomSystem()"></apm-convertible-input>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">{{ 456942 | apmTranslate }}</div>
      <div class="chiller-free-st-field-control">
        <apm-select
          [items]="evapInletTypes"
          [clearable]="false"
          [useResourceTemplate]="true"
          bindLabel="resourceId"
          bindValue="id"
          formControlName="evapOutletType"
        ></apm-select>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">
        {{ 456944 | apmTranslate }}
        @if (fieldMappings().evapOutletTemp.symbol) {
          [{{ fieldMappings().evapOutletTemp.symbol }}]
        }
        *
      </div>
      <div class="chiller-free-st-field-control">
        <apm-convertible-input formControlName="evapOutletTemp" [mapping]="fieldMappings().evapOutletTemp.mapping" [uomSystem]="store.uomSystem()"></apm-convertible-input>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">
        {{ 456945 | apmTranslate }}
      </div>
      <div class="chiller-free-st-field-control">
        <input apmInput type="number" class="w-100" formControlName="evapVarFlowPct" />
        <apm-field-errors [control]="form.controls.evapVarFlowPct"></apm-field-errors>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">
        {{ 34914 | apmTranslate }}
        @if (fieldMappings().evapFoulingFactor.symbol) {
          [{{ fieldMappings().evapFoulingFactor.symbol }}]
        }
      </div>
      <div class="chiller-free-st-field-control">
        <apm-select
          [items]="convertedFoulingFactorValList()"
          [clearable]="false"
          bindLabel="val"
          bindValue="id"
          formControlName="evapFFId"
        ></apm-select>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">
        {{ 456939 | apmTranslate }}
        @if (fieldMappings().evapPD.symbol) {
          [{{ fieldMappings().evapPD.symbol }}]
        }
      </div>
      <div class="chiller-free-st-field-control">
        <apm-convertible-input formControlName="evapPD" [mapping]="fieldMappings().evapPD.mapping" [uomSystem]="store.uomSystem()"></apm-convertible-input>
      </div>
    </div>
  </div>

  <!-- CONDENSER -->
  <div class="apm-card shadow">
    <div class="chiller-free-st-card-title">{{ 457033 | apmTranslate }}</div>
    <hr class="card-divider" />

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">{{ 456941 | apmTranslate }}</div>
      <div class="chiller-free-st-field-control">
        <apm-select
          [items]="condOutletTypes"
          [clearable]="false"
          [useResourceTemplate]="true"
          bindLabel="resourceId"
          bindValue="id"
          formControlName="condInletType"
        ></apm-select>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">
        {{ 456943 | apmTranslate }}
        @if (fieldMappings().condInletTemp.symbol) {
          [{{ fieldMappings().condInletTemp.symbol }}]
        }
        *
      </div>
      <div class="chiller-free-st-field-control">
        <apm-convertible-input formControlName="condInletTemp" [mapping]="fieldMappings().condInletTemp.mapping" [uomSystem]="store.uomSystem()"></apm-convertible-input>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">{{ 456942 | apmTranslate }}</div>
      <div class="chiller-free-st-field-control">
        <apm-select
          [items]="condOutletTypes"
          [clearable]="false"
          [useResourceTemplate]="true"
          bindLabel="resourceId"
          bindValue="id"
          formControlName="condOutletType"
          (selectChange)="onCondOutletTypeChange()"
        ></apm-select>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">
        {{ 456944 | apmTranslate }}
        @if (fieldMappings().condOutletVal.symbol) {
          [{{ fieldMappings().condOutletVal.symbol }}]
        }
        *
      </div>
      <div class="chiller-free-st-field-control">
        <apm-convertible-input formControlName="condOutletVal" [mapping]="fieldMappings().condOutletVal.mapping" [uomSystem]="store.uomSystem()"></apm-convertible-input>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">
        {{ 456945 | apmTranslate }}
      </div>
      <div class="chiller-free-st-field-control">
        <input type="number" class="w-full" apmInput formControlName="condVarFlowPct" />
        <apm-field-errors [control]="form.controls.condVarFlowPct"></apm-field-errors>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">
        {{ 34914 | apmTranslate }}
        @if (fieldMappings().condFoulingFactor.symbol) {
          [{{ fieldMappings().condFoulingFactor.symbol }}]
        }
      </div>
      <div class="chiller-free-st-field-control">
        <apm-select
          [items]="convertedFoulingFactorValList()"
          [clearable]="false"
          bindLabel="val"
          bindValue="id"
          formControlName="condFFId"
        ></apm-select>
      </div>
    </div>

    <div class="chiller-free-st-field-row">
      <div class="chiller-free-st-field-label">
        {{ 456939 | apmTranslate }}
        @if (fieldMappings().condPD.symbol) {
          [{{ fieldMappings().condPD.symbol }}]
        }
      </div>
      <div class="chiller-free-st-field-control">
        <apm-convertible-input formControlName="condPD" [mapping]="fieldMappings().condPD.mapping" [uomSystem]="store.uomSystem()"></apm-convertible-input>
      </div>
    </div>
  </div>
</form>
